import React from 'react';
import { 
  Button, 
  Dropdown, 
  DropdownMenu, 
  DropdownItem, 
  DropdownToggle, 
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation, withTranslation } from 'react-i18next';

import { logout } from '../../redux/actions/actions';
import { useDropdown } from '../../hooks/useDropdown';
import SettingsModal from '../../views/Component/Modals/SettingsModal';
import ChangePasswordModal from '../../views/Component/Modals/ChangePasswordModal';

const DefaultLayoutDropdownHeader = ({userinfo = "", className}) => {
  const { t } = useTranslation(); 
  const dispatch = useDispatch();
  const history = useHistory();
                                
  const [ values , handleDropDownChange ] = useDropdown({
    isSettingsModalShow: false,
    isChangePasswordModalShow: false,
    dropdownOpen: false,
    modalLogout: false,
  }, 
    'dropdownOpen'
  );

  const { 
    isChangePasswordModalShow,
    isSettingsModalShow,
    dropdownOpen,
    modalLogout, 
  } = values;

  /** Component functions!! */
  const changePassword = () => {
      history.push({
        pathname: "/change-password"//,
      });
  };

  const logoutFn = async() => {
      dispatch(logout());    
  }
    
  console.log('DefaultLayoutDropdownHeader - userinfo: ', userinfo);
  // Nombre a mostrar en el header
  const info = userinfo ? userinfo.firstname + " " + userinfo.lastname : "";

  // Navega a la pantalla de configuracion de MFA
  const goToMfaSettings = () => {
    history.push('/mfa-settings');
  };

  return (
    <div>
      {isSettingsModalShow && (
          <SettingsModal
          shown={isSettingsModalShow}
          toggleClose={handleDropDownChange}
          userinfo={userinfo}
          name="isSettingsModalShow"
          title={t("DefaultLayout.settings")}
          />
      )}

      {isChangePasswordModalShow && (
          <ChangePasswordModal
            shown={isChangePasswordModalShow}
            toggleClose={ handleDropDownChange }
            userId={userinfo.userId}
            username={userinfo.username}
            hiddenChangePassword
            shownVarName="isChangePasswordModalShow"
          />
      )}

      {modalLogout && (
        <Modal
          isOpen={modalLogout}
          toggle={handleDropDownChange}
          className={"modal-sm modal-secondary " + className}
          name="modalLogout"
        >
          <ModalBody>{t("DefaultLayout.logoutMessage")}</ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => logoutFn()}>
              {t("DefaultLayout.closeButton")}
            </Button>
            <Button
              color="secondary"
              onClick={handleDropDownChange}
              name="modalLogout"
            >
              {t("DefaultLayout.backButton")}
            </Button>
          </ModalFooter>
        </Modal>
      )}

      <div>                  
        <button
          type="button"
          hidden={userinfo.reqChangePassword === 0}
          onClick={handleDropDownChange}
          className="button-change-password"
          name="isChangePasswordModalShow"
        >
          {t("DefaultFooter.changePassword")}
        </button>
      </div>

      <div
        className="text-right"
        style={{ display: "inherit", marginRight: "45px" }}
      >
        
        {/** Este componente dropdown */}
        <Dropdown
          className="d-xs-down-none"
          isOpen={ dropdownOpen }
          toggle={handleDropDownChange}
          name="dropdownOpen"
        >
          <DropdownToggle nav style={{ padding: 4 }}>
            <Button
              size="sm"
              style={{ marginRight: -13 }}
              color="white"
              onClick={handleDropDownChange}
              name="dropdownOpen"
            >
              {info}
            </Button> 
          </DropdownToggle>

          <DropdownMenu>
            <DropdownItem 
              onClick={ handleDropDownChange }
              name="isChangePasswordModalShow"
            >
              <i className="cui-wrench text-info" />{" "}
              {t("DefaultLayout.changePassword")}
            </DropdownItem>

            <DropdownItem 
              onClick={handleDropDownChange}
              name="isSettingsModalShow" 
            >
              <i className="cui-pencil text-info" />{" "}
              {t("DefaultLayout.settings")}
            </DropdownItem>

            {/* Configuracion de MFA (Authenticator / futuro Email) */}
            <DropdownItem
              onClick={(e) => {
                handleDropDownChange(e);
                goToMfaSettings();
              }}
              name="dropdownOpen"
            >
              <i className="cui-lock-locked text-warning" />{" "}
              {t("DefaultLayout.MfaSettings")}
            </DropdownItem>

            <DropdownItem 
              onClick={handleDropDownChange}
              name="modalLogout"
            >
              <i className="cui-circle-x text-danger" />{" "}
              {t("DefaultLayout.logout")}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>      
  )
}

export default (withTranslation()(DefaultLayoutDropdownHeader));